export default "__VITE_ASSET__BXRHODzj__"